module.exports = __webpack_public_path__ + "static/media/np_safety.bbff6579.svg";